


























































































import { Component, Vue, Lifecycle, Mixin, Prop, p } from 'av-ts'
import { EventBus } from '@/eventbus'
import { ITestResult, IUser } from '@/models'
import { StoreType } from '@/store'

@Component({
  store: [],
})
export default class TestResult extends Mixin(EventBus) {
  $store!: StoreType
  @Prop testResultId = p({
    type: String,
    required: true
  })

  testResult = null as ITestResult | null

  resultDetails = [] as any[]

  onlyErrors = false

  get totalCorrectProgress(): number {
    if (! this.testResult) return 0
    return this.testResult.correctAnswers / this.testResult.questionCount * 100
  }

  get totalWrongProgress(): number {
    if (! this.testResult) return 0
    return this.testResult.wrongAnswers / this.testResult.questionCount * 100
  }

  get score(): string | undefined {
    if (! this.testResult) return undefined
    return `${Math.round(this.totalCorrectProgress)} %`
  }

  get passTest(): boolean {
    return this.totalCorrectProgress >= 70
  }

  get filteredItems(): any[] {
    if (this.onlyErrors) {
      return this.resultDetails.filter(item => !item.isCorrect)
    } else {
      return this.resultDetails
    }
  }

  @Lifecycle
  async created() {
    console.debug('[TestResult.vue] created')
    console.debug('[TestResult.vue] testResultId =', this.testResultId)

    this.testResult = await this.$store.getTestResult(this.testResultId) || null
    if (this.testResult) {
      const langMap: {[key: string]: string} = {}
      langMap[this.testResult.lesson.srcLang] = this.testResult.lesson.tgtLang
      langMap[this.testResult.lesson.tgtLang] = this.testResult.lesson.srcLang

      const answers = this.testResult.answers
      this.testResult.questions.forEach((word, idx) => {
        this.resultDetails.push({
          srcLang: word.lang,
          tgtLang: langMap[word.lang],
          word: word.word,
          answer: answers[idx].value,
          isCorrect: answers[idx].correct
        })
      })
    }
  }

}
